export default "__VITE_ASSET__0881105b__"